import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { Get } from "../config/api/get";
import { ADMIN } from "../config/constants";

export const useDashboardOverview = (params = {}) => {
  const token = useSelector((state) => state.user.userToken);

  return useQuery({
    queryKey: ["dashboard-overview", params],
    queryFn: async () => {
      const response = await Get(ADMIN.dashboardOverview, token, params);
      if (!response?.status) {
        throw new Error(response?.message || "Failed to load dashboard");
      }
      return (
        response.data || {
          stats: {},
          attendance: {},
          calendar: { marks: [], monthItems: [], upcoming: [] },
        }
      );
    },
    enabled: !!token,
    placeholderData: keepPreviousData,
  });
};
